import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import App from './App';
import './styles.css';
import { debugLog, debugError } from './utils/debug';

// Ensure React is available globally for framer-motion and other libraries
// that might access React.useLayoutEffect
if (typeof window !== 'undefined') {
  window.React = React;
}

const theme = extendTheme({
  components: {
    IconButton: {
      defaultProps: {
        variant: 'ghost',
        size: 'lg'
      }
    }
  },
  colors: {
    brand: {
      100: '#E3F2FD',
      200: '#90CAF9',
      300: '#64B5F6',
      400: '#42A5F5',
      500: '#2196F3',
      600: '#1E88E5',
      700: '#1976D2',
      800: '#1565C0',
      900: '#0D47A1',
    },
  },
});

debugLog('main', 'init', 'Starting application initialization', 1);

try {
  const rootElement = document.getElementById('root');
  debugLog('main', 'root-element', rootElement ? 'Found root element' : 'Root element not found', 1);

  if (!rootElement) {
    throw new Error('Root element not found');
  }

  const root = ReactDOM.createRoot(rootElement);
  debugLog('main', 'create-root', 'React root created', 1);

  root.render(
    <React.StrictMode>
      <ChakraProvider theme={theme}>
        <App />
      </ChakraProvider>
    </React.StrictMode>
  );
  debugLog('main', 'render', 'Initial render completed', 1);
} catch (error) {
  debugError('main', 'fatal-init', error);
}